import React, { useContext } from 'react';
import { useEffect } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import {Accordion, AccordionDetails, AccordionSummary, TextField} from "@mui/material";
import WaitSpinner from "../../components/wait-spinner";

// eslint-disable-next-line react/display-name
function DistributorForm({diaForm,waiting}) {
    const {values,errors,handleSubmit,onChange,isDirty,status} = diaForm;
    const id = values?.id;
    const isNew = id === 'new';
    const baseUrl = '/database/distributors/';
    const toolbarContext = useContext(ToolbarContext);
    const field = {
        onChange: onChange,
    };
    useEffect(() => {
        const buttons = [{
            type: 'button',
            icon: 'save',
            tooltip: 'Save',
            callback: handleSubmit,
            label: 'Save',
            disabled: !isDirty
        }];
        toolbarContext.setSecondary(
            {
                primaryUrl:baseUrl,
                title: (!isNew ? values.name : 'New Distributor'),
                secondary: buttons,
                secondaryUrl: id
            });
    }, [isDirty, id, status,isNew]);
    return (
        <Accordion defaultExpanded={true}>
            {waiting && <WaitSpinner variant="overlay"/>}
            <AccordionSummary>Distributor</AccordionSummary>
            <AccordionDetails className="grid12">

                <TextField name="name" {...field} value={values?.name} error={!!errors?.name} label="Name"/>
                <TextField type="email" name="email" {...field} value={values?.email} error={!!errors?.email} label="Email"/>
            </AccordionDetails>
        </Accordion>
    );
}

export default DistributorForm;
